/**
 * 错误路由
 */
export default [
  {
    path: '/401',
    meta: {
      hidden: true,
      errorCode: 401,
      title: '401 - 未授权'
    },
    component: () => import('@/views/error/index.vue')
  },
  {
    path: '/403',
    meta: {
      hidden: true,
      errorCode: 403,
      title: '403 - 无权限'
    },
    component: () => import('@/views/error/index.vue')
  },
  {
    path: '/404',
    meta: {
      hidden: true,
      errorCode: 404,
      title: '404 - 页面不存在'
    },
    component: () => import('@/views/error/index.vue')
  }
];
